import { AddOnArray, registerToFavoriteArray } from '../../components/addon/addonRegister'
import { InsertFormBoxClassArray } from '../../components/addon/addons/parts/forEachInsertForm/generatingBoxClasses'
import Firestore from '../initFirebase'
import { globalOnDemandVars } from '../../helper/context'

export async function initAddOns () {
  globalOnDemandVars.set_addOnsReady(false)
  const AllAddOnArray = AddOnArray.concat(InsertFormBoxClassArray)

  // const AddOnConfigCollection = Firestore.collection('AddOnConfig')
  const AddOnConfigCollection = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('AddOnConfig')
  const snapshot = await AddOnConfigCollection.get()
  const results = {}
  snapshot.forEach((doc) => {
    results[doc.id] = doc.data()
    // results.push({
    //   id: doc.id,
    //   ...doc.data()
    // })
  })

  AllAddOnArray.forEach((oneAddOnClass) => {
    let AddOnConfig = results[oneAddOnClass.id]
    if (!AddOnConfig) {
      AddOnConfig = {
        order: oneAddOnClass.order,
        favoriteOrder: oneAddOnClass.favoriteOrder,
        isFavorite: oneAddOnClass.isFavorite,
        initialHeight: oneAddOnClass.initialHeight,
        initialHeightForFavorite: oneAddOnClass.initialHeightForFavorite
      }
      AddOnConfigCollection.doc(oneAddOnClass.id).set(AddOnConfig)
    }
    updateLocalAddOnFromCloud(oneAddOnClass, AddOnConfig)
  })

  registerToFavoriteArray()
  globalOnDemandVars.set_addOnsReady(true)
}

function updateLocalAddOnFromCloud (oneAddOnClass, AddOnFromCloud) {
  oneAddOnClass.setFromCloud(AddOnFromCloud)
}
